var _classCallCheck = require("/Users/pietvandeput/WebstormProjects/tetris-react/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/pietvandeput/WebstormProjects/tetris-react/node_modules/@babel/runtime/helpers/createClass");

/**
 * Max dimension of every shape
 */
var ShapeDimension = 5;
/**
 * Implements a falling shape
 */

var Shape =
/*#__PURE__*/
function () {
  "use strict";

  function Shape(shapesSet) {
    var X = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
    var Y = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 12;

    _classCallCheck(this, Shape);

    if (!shapesSet) console.error('Set of shapes was not setted!');
    this._shape = this._selectNextShape(shapesSet);
    this.position = {
      X: X,
      Y: Y
    };

    this._calculateProperties();
  }
  /**
   * Selecting next shape from the available set of shapes
   * @private
   */


  _createClass(Shape, [{
    key: "_selectNextShape",
    value: function _selectNextShape(shapesSet) {
      var count = 0;
      var selectedShape;

      for (var prop in shapesSet) {
        if (Math.random() < 1 / ++count) selectedShape = prop;
      }

      this.name = selectedShape;
      return shapesSet[selectedShape];
    }
    /**
     * Calculating all properties that change when a shape is rotated
     * @private
     */

  }, {
    key: "_calculateProperties",
    value: function _calculateProperties() {
      this._calculatePaddings();
    }
    /**
     * Calculating paddings
     */

  }, {
    key: "_calculatePaddings",
    value: function _calculatePaddings() {
      var paddingLeft = ShapeDimension;
      var paddingRight = ShapeDimension;
      var paddingTop = -1;
      var paddingBottom = -1;

      for (var y = 0; y < ShapeDimension; y++) {
        for (var x = 0; x < ShapeDimension; x++) {
          if (this._shape[y][x]) {
            if (paddingLeft > x) paddingLeft = x;
            if (paddingTop < 0) paddingTop = y;
          }
        }
      }

      for (var _y = ShapeDimension - 1; _y >= 0; _y--) {
        for (var _x = ShapeDimension - 1; _x >= 0; _x--) {
          if (this._shape[_y][_x]) {
            if (paddingRight > ShapeDimension - 1 - _x) paddingRight = ShapeDimension - 1 - _x;
            if (paddingBottom < 0) paddingBottom = ShapeDimension - 1 - _y;
          }
        }
      }

      this._paddingLeft = paddingLeft;
      this._paddingRight = paddingRight;
      this._paddingTop = paddingTop;
      this._paddingBottom = paddingBottom;
    }
    /**
     * rotating a shape clockwise
     * @public
     */

  }, {
    key: "rotate",
    value: function rotate() {
      this._shape = this.getRotatedBody();

      this._calculateProperties();
    }
  }, {
    key: "getRotatedBody",
    value: function getRotatedBody() {
      var newShape = [];

      for (var x = 0; x < ShapeDimension; x++) {
        var newRow = [];

        for (var y = ShapeDimension - 1; y >= 0; y--) {
          newRow.push(this._shape[y][x]);
        }

        newShape.push(newRow);
      }

      return newShape;
    }
    /**
     * rotating a shape counterclockwise
     * @public
     */

  }, {
    key: "rotateBack",
    value: function rotateBack() {
      this._shape = this.getRotatedBackBody();

      this._calculateProperties();
    }
  }, {
    key: "getRotatedBackBody",
    value: function getRotatedBackBody() {
      var newShape = [];

      for (var x = ShapeDimension - 1; x >= 0; x--) {
        var newRow = [];

        for (var y = 0; y < ShapeDimension; y++) {
          newRow.push(this._shape[y][x]);
        }

        newShape.push(newRow);
      }

      return newShape;
    }
    /**
     * getting actual shape body
     * @public
     */

  }, {
    key: "body",
    get: function get() {
      return this._shape;
    }
    /**
     * getting top padding for shape relatively shape's border
     * @public
     */

  }, {
    key: "paddingTop",
    get: function get() {
      return this._paddingTop;
    }
    /**
      * getting bottom padding for shape relatively shape's border
      * @public
      */

  }, {
    key: "paddingBottom",
    get: function get() {
      return this._paddingBottom;
    }
    /**
      * getting right padding for shape relatively shape's border
      * @public
      */

  }, {
    key: "paddingRight",
    get: function get() {
      return this._paddingRight;
    }
    /**
      * getting left padding for shape relatively shape's border
      * @public
      */

  }, {
    key: "paddingLeft",
    get: function get() {
      return this._paddingLeft;
    }
  }]);

  return Shape;
}();

module.exports = {
  Shape: Shape,
  ShapeDimension: ShapeDimension
};